/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DescribeMappableEntityRequest
 */
export interface DescribeMappableEntityRequest {
    /**
     * 
     * @type {string}
     * @memberof DescribeMappableEntityRequest
     */
    entityName: string;
}

/**
 * Check if a given object implements the DescribeMappableEntityRequest interface.
 */
export function instanceOfDescribeMappableEntityRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entityName" in value;

    return isInstance;
}

export function DescribeMappableEntityRequestFromJSON(json: any): DescribeMappableEntityRequest {
    return DescribeMappableEntityRequestFromJSONTyped(json, false);
}

export function DescribeMappableEntityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeMappableEntityRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityName': json['entityName'],
    };
}

export function DescribeMappableEntityRequestToJSON(value?: DescribeMappableEntityRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entityName': value.entityName,
    };
}

